import { Box, BoxProps, styled, SxProps } from "@mui/material";

export type IBadgeBox = {
  children: JSX.Element | string;
  background: string;
  border: string;
  textColor: string;
  completed?: boolean;
  sx?: SxProps
}


export const BadgeBox = ({ children, completed, background, border, textColor,sx }: IBadgeBox) => {

  return (
    <StyledBadgeBox
      tabIndex={ -1 }
      width="fit-content"
      boxSizing="content-box"
      height={ "1rem" }
      color={ textColor }
      border={ border }
      sx={ { 
        ...sx,
        background: `${background} !important`,
        fontWeight: 600 
      } }
      padding={ "0.11rem 0.44rem" }
      gap={ "0.1875rem" }
      $completed={ completed ?? false }
    >
      { children }
    </StyledBadgeBox>
  );};


const StyledBadgeBox = styled(Box)<
  BoxProps & { $completed: boolean, $absolute?: boolean }
>(({ $completed, theme }) => ({
  alignItems: "center",
  background: $completed ? "#757575" : "#000",
  borderRadius: "0.25rem",
  boxSizing: "border-box",
  display: "flex",
  fontSize: "0.76875rem",
  fontWeight: 400,
  gap: "0.25rem",
  padding: "0.10938rem 0.4375rem",
  height: "1.5rem",
  pointerEvents: "none",
  "svg path": {
    fill: theme.customColors.textTag
  },
  "svg.lucide path, svg.lucide circle, svg.lucide rect, svg.lucide polyline, svg.lucide line": {
    fill: "none",
    stroke: theme.customColors.textTag
  },
  "& > span": {
    lineHeight: "1.09375rem"
  }
}));
